import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-schedule-pickup',
  templateUrl: './schedule-pickup.component.html',
  styleUrls: ['./schedule-pickup.component.scss'],
})
export class SchedulePickupComponent implements OnInit {
  bookingForm: FormGroup;
  addBoxForm: FormGroup;

  currentStep: number = 1;
  totalSteps: number = 3;

  private addBoxModal!: Modal;

  constructor(private fb: FormBuilder) {
    this.bookingForm = this.fb.group({
      senderFirstName: ['', Validators.required],
      senderLastName: ['', Validators.required],
      senderEmail: ['', [Validators.required, Validators.email]],
      senderPhone: ['', Validators.required],
      senderAddress: ['', Validators.required],
      senderAddress2: [''],
      senderCountry: ['', Validators.required],
      senderState: ['', Validators.required],
      senderCity: ['', Validators.required],
      senderZipCode: ['', Validators.required],

      consigneeFirstName: ['', Validators.required],
      consigneeLastName: ['', Validators.required],
      consigneePhone: ['', Validators.required],
      consigneePhone2: [''],
      consigneeAddress: ['', Validators.required],
      consigneeState: ['', Validators.required],
      consigneeCity: ['', Validators.required],
      consigneeZipCode: ['', Validators.required],

      serviceType: ['', Validators.required],
      boxes: this.fb.array([]),
    });

    this.addBoxForm = this.fb.group({
      boxSize: ['', Validators.required],
      items: this.fb.array([this.createItemForm()]),
    });
  }

  ngOnInit(): void {}

  get boxes(): FormArray {
    return this.bookingForm.get('boxes') as FormArray;
  }

  get items(): FormArray {
    return this.addBoxForm.get('items') as FormArray;
  }

  addItem() {
    this.items.push(this.createItemForm());
  }

  removeItem(index: number) {
    this.items.removeAt(index);
  }

  createItemForm(): FormGroup {
    return this.fb.group({
      description: ['', Validators.required],
      qty: [1, [Validators.required, Validators.min(1)]],
      price: [1, [Validators.required, Validators.min(0)]],
      condition: ['New', Validators.required],
    });
  }

  openAddBoxModal() {
    const modalElement = document.getElementById('addBoxModal');
    if (modalElement) {
      this.addBoxModal = new Modal(modalElement);
      this.addBoxModal.show();
    }
  }

  saveBox() {
    if (this.addBoxForm.valid) {
      this.boxes.push(this.fb.group(this.addBoxForm.value));
      this.addBoxModal.hide();
      this.addBoxForm.reset();
    }
  }

  nextStep(): void {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
    }
  }

  prevStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  onSubmit(): void {
    if (this.bookingForm.valid) {
      console.log('Booking Form Data:', this.bookingForm.value);
    } else {
      console.log('Form is invalid');
    }
  }

  isStepValid(step: number): boolean {
    switch (step) {
      case 1:
        return (
          this.bookingForm.get('senderFirstName')?.valid &&
          this.bookingForm.get('senderLastName')?.valid &&
          this.bookingForm.get('senderEmail')?.valid &&
          this.bookingForm.get('senderPhone')?.valid &&
          this.bookingForm.get('senderAddress')?.valid
        );
      case 2:
        return (
          this.bookingForm.get('consigneeFirstName')?.valid &&
          this.bookingForm.get('consigneeLastName')?.valid &&
          this.bookingForm.get('consigneePhone')?.valid &&
          this.bookingForm.get('consigneeAddress')?.valid
        );
      case 3:
        return (
          this.bookingForm.get('serviceType')?.valid && this.boxes.length > 0
        );
      default:
        return false;
    }
  }

  boxImages: { [key: string]: string } = {
    DOYDOY: 'assets/img/boxes/doydoy-box.png',
    POPBOX: 'assets/img/boxes/pop-box.png',
    ALIBOX: 'assets/img/boxes/ali-box.png',
    IRREGULARBOX: 'assets/img/boxes/download-mobile-app.png',
    HANNAHBOX: 'assets/img/boxes/hannah-box.png',
  };

  debugForm() {
    console.log('Booking:', this.bookingForm);
  }
}
